"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentDefineApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var contentDefineApi = {
  findAll: function findAll() {
    return (0, _request.default)({
      url: "/v1/admin/contentDefine"
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/v1/admin/contentDefine/".concat(id, "/update"),
      method: "POST",
      data: data
    });
  }
};
exports.contentDefineApi = contentDefineApi;